import { authedFetch, readApiError } from "./client";

/**
 * `VITE_USE_MOCK=1` streams a local judge and has no backend, so `/me` is
 * mocked too (the limit dialog needs a `nextAvailableAt` to count down to).
 */
const USE_MOCK = import.meta.env.VITE_USE_MOCK === "1";

export interface Me {
  name: string | null;
  avatarUrl: string | null;
  /** The questions-per-24h limit that applies to this user, null if unknown. */
  dailyLimit: number | null;
  /** Questions left in the rolling window, null if unknown. */
  questionsLeft: number | null;
  /** When the next question unlocks (ISO 8601), null if not applicable. */
  nextAvailableAt: string | null;
}

/** The signed-in user's profile and question allowance (`GET /me`). */
export async function getMe(): Promise<Me> {
  if (USE_MOCK) {
    return {
      name: null,
      avatarUrl: null,
      dailyLimit: 10,
      questionsLeft: 3,
      nextAvailableAt: new Date(Date.now() + 2 * 60 * 60 * 1000).toISOString(),
    };
  }

  const response = await authedFetch("/me");
  if (!response.ok) throw await readApiError(response);
  return response.json();
}
